import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UserDetailsComponent} from './user-details.component';
import {TranslateModule} from '@xref/ngx';
import {HeaderModule} from "../header/header.module";
import {FooterModule} from "../footer/footer.module";
import {ButtonModule, DropdownModule, InputsModule} from "@xref/xref-lib";
import {FormsModule} from "@angular/forms";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {OmniLoaderModule} from "../omni-loader/omni-loader.module";

@NgModule({
    declarations: [UserDetailsComponent],
    imports: [FormsModule,
        CommonModule,
        TranslateModule,
        HeaderModule,
        FooterModule,
        InputsModule,
        ButtonModule,
        TooltipModule,
        OmniLoaderModule,
        DropdownModule
    ],
    exports: [UserDetailsComponent]
})
export class UserDetailsModule {
}
